import React from 'react'

import { SearchCriteria } from './helpers'
import {
  defaultCriteria,
  PendingSearchContext,
  SearchContext,
} from './useSearchContext'

export function SearchProvider({ children }: { children: React.ReactNode }) {
  const [criteria, setCriteria] =
    React.useState<SearchCriteria>(defaultCriteria)

  const [pendingCriteria, setPendingCriteria] =
    React.useState<SearchCriteria>(defaultCriteria)

  const mergePendingCriteria = (val: Partial<SearchCriteria>) =>
    setPendingCriteria({
      ...pendingCriteria,
      ...val,
    })

  return (
    <SearchContext.Provider value={{ criteria, setCriteria }}>
      <PendingSearchContext.Provider
        value={{ pendingCriteria, setPendingCriteria, mergePendingCriteria }}
      >
        {children}
      </PendingSearchContext.Provider>
    </SearchContext.Provider>
  )
}
